export default {
  info: '#63C7A9',
  primary: '#031e3b',
  success: '#031e3b',
  warning: '#ffc72b',
  danger: '#EB0045',
}
